import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const Description = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	ul {
		padding: 0;
		margin: 0;
	}

	li {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
	}

	li + li {
		margin-top: 13px;
	}

	img {
		width: 22px;
		height: 22px;
		margin-right: 10px;
		object-fit: contain;
	}

	p {
		color: #000;
		font-size: 16px;
		line-height: 22px;

		span {
			font-weight: 700;
		}
	}
`;

export const Disclaimer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	border-radius: 5px;
	border: 2px solid #dbd9f7;
	background: #f3f2f9;
	padding: 20px;
	margin-top: 30px;
	margin-bottom: 30px;

	p,
	h4,
	h3 {
		margin: 0;
		color: #000;
		font-size: 16px;
		line-height: 20px;
	}

	h4,
	h3 {
		font-weight: 700;
	}

	h3 {
		text-transform: uppercase;
		display: flex;
	}

	h3,
	p {
		margin-top: 10px;
	}
`;
